<template>
    <div class="DescWrapper cardWidth shadowRadius cardPadding cardMinHeight">
        <div :class="['tipsGlobalText','clearMarginCls']" v-show="tips!=''" v-html="newTips"></div>
    </div>
</template>
<script>
    export default {
        name: "DescBox",
        components: {},
        props: {
            tips: {
                type: String,
                default:''
            },
            list: {
                type: Object,
                default:()=>{}
            },
        },
        data() {
            return {};
        },
        computed: {
            newTips(){
                let newTips = this.onSlice(this.tips)
                return newTips
            }
        },
        methods: {
            onSlice(tips) {
                let posIndex = [],
                    len = tips.length,
                    pos = 0;
                while (pos < len) {
                    pos = tips.indexOf('data-w-e="1"', pos);
                    if (pos === -1) {//未找到就退出循环完成搜索
                        break;
                    }
                    posIndex.push(pos);//找到就存储索引
                    pos += 1;//并从下个位置开始搜索
                }
                posIndex.map((item, index) => {
                    if (index === 0) {
                        tips = tips.slice(0, item + 12) + ' class="emoji"' + tips.slice(item + 12)
                    } else {
                        tips = tips.slice(0, item + 12 + 14 * index) + ' class="emoji"' + tips.slice(item + 12 + 14 * index)
                    }

                })
                // console.log(tips)
                return tips;
            }
        }
    }
</script>
<style lang="less" scoped>
    .DescWrapper {

    }
</style>
